module.exports = __webpack_public_path__ + "img/longue-vue.0f2b59c8.webp";